'use strict';

var ChartDashboardScheduleService = function ChartDashboardScheduleService() {
  function prepareData(data) {
    var result = [];
    var dataKeys = Object.keys(data);
    for (var index = 0, dataLength = dataKeys.length; index < dataLength; index++) {
      if (dataKeys[index] !== 'metrics') {
        var element = data[dataKeys[index]];
        var item = {
          label: dataKeys[index],
          stackLabel: dataKeys[index],
          data: element,
          metrics: data.metrics[dataKeys[index]]
        };
        result.push(item);
      }
    }
    return result;
  }
  return {
    prepareData: prepareData
  };
};
ChartDashboardScheduleService.$inject = [];
module.exports = ChartDashboardScheduleService;